import { emptyDataAreaInfoBoxArea } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/info-boxes/empty-data-area-info-box-layout';
import { Bounds, Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { ReactNode, CSSProperties } from 'react';
import styled from 'styled-components';
import { useCarouselLayout } from '../../../../context';

interface Props {
  side: Side;
  text: ReactNode;
  referenceArea?: Bounds;
}

export function EmptyDataAreaInfoBox(props: Props) {
  const baseLayout = useCarouselLayout();
  const area = props.referenceArea || emptyDataAreaInfoBoxArea(baseLayout, props.side);
  const style: CSSProperties = {
    position: 'absolute',
    top: area.y1,
    width: area.width,
    left: area.x1,
    height: area.height,
  };
  return <Root style={style}>{props.text}</Root>;
}

const Root = styled.div`
  background: repeating-linear-gradient(45deg, #f9f9f9, #f9f9f9 10px, #eeeeee 12px, #eeeeee 12px);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.35;
  padding: 2.5em;
`;
